<template>
  <!-- HEAD -->
  <div class="container-xxl">
    <!-- titol -->
    <div class="row justify-content-between">
      <div class="col-12 col-lg-4 py-4 text-start">
        <p class="txtBlau2 my-0">{{ $t('site.avanzando-hacia-el-futuro')}}</p>
        <h2 class="h2Trans text-uppercase">{{ $t("nav.transformacion-digital") }}</h2>
      </div>
      <div class="col-6 text-start py-5 d-none d-lg-block">
        <h5>{{ $t("transformacion.Junto-con") }}</h5>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <!-- foto -->
    <div class="row">
      <div class="col-12 p-0 m-0 overflow-hidden">
        <img :src="`${publicPath}img/01avanzandoTransformacion.jpg`" class="img-responsive" id="imgTransformacion">
      </div>
    </div>
    <div class="row d-block d-lg-none">
      <div class="col-11 mx-3 mt-3 text-start">
        <h5>{{ $t("transformacion.Junto-con") }}</h5>
      </div>
    </div>

  </div>
  <!-- end HEAD -->

  <!-- Content -->
  <div class="container-xxl">
    <div class="franjaODS d-none d-lg-block">
      <ul>
        <li class="odsTxt">{{ $t('site.ODS-impacto-directo')}}</li>
        <li><img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive"></li>
        <li><img :src="`${publicPath}img/ods6_${locale}.gif`" class="img-responsive"></li>
        <li><img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive"></li>
        <li><img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive"></li>
        <li style="width: 90px"></li>
        <li class="odsTxt">{{ $t('site.ODS-impacto-indirecto')}}</li>
        <li><img :src="`${publicPath}img/ods7_${locale}.gif`" class="img-responsive"></li>
        <li><img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive"></li>
        <li><img :src="`${publicPath}img/ods13_${locale}.gif`" class="img-responsive"></li>
        <li><img :src="`${publicPath}img/ods17_${locale}.gif`" class="img-responsive"></li>
      </ul>
    </div>
    <div class="franjaODS d-block d-lg-none">
      <div class="row justify-content-between p-0 m-0">
        <div class="col-12 odsTxt">
          <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
          <ul>
            <li>
              <img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive">
            </li>
            <li>
              <img :src="`${publicPath}img/ods6_${locale}.gif`" class="img-responsive">
            </li>
            <li>
              <img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive">
            </li>
            <li>
              <img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive">
            </li>
          </ul>
        </div>
        <div class="col-12 odsTxt">
          <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
          <ul>
            <li>
              <img :src="`${publicPath}img/ods7_${locale}.gif`" class="img-responsive">
            </li>
            <li>
              <img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive">
            </li>
            <li>
              <img :src="`${publicPath}img/ods13_${locale}.gif`" class="img-responsive">
            </li>
            <li>
              <img :src="`${publicPath}img/ods17_${locale}.gif`" class="img-responsive">
            </li>
          </ul>

        </div>
      </div>
    </div>

  </div>

  <div class="container-fluid bg-dark">
    <div class="container-xxl">
      <div class="row justify-content-between g-3 mt-2">
        <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
          <div class="pt-5 text-start">
            <h2 class="mb-5">{{ $t("transformacion.Baños-inteligentes") }}</h2>
            <h5 class="txtGris">{{ $t("transformacion.Las-plataformas") }}</h5>
          </div>
        </div>
        <div class="col-12 col-lg-6 m-0 p-0 mt-5 pt-3 text-end position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
          <img :src="`${publicPath}img/01avanzandoTransformacionA_${locale}.jpg`" class="img-responsive text-end d-none d-lg-block">
          <img :src="`${publicPath}img/01avanzandoTransformacionAMobile_${locale}.jpg`" class="img-responsive text-end d-block d-lg-none">
        </div>
      </div>
      <div class="row justify-content-between g-3 mt-2">
        <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
          <div class="pt-5 text-start">
            <h5 class="txtBlau">{{ $t("transformacion.Por-su-capacidad") }}</h5>
          </div>
        </div>
        <div class="col-12 col-lg-6 mt-5 position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
          <div class="row g-3 mt-2 pb-5">
            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
              <div class="boxGris p-4 pb-0 fullHeight">
                <svg viewBox="-5 0 60 60" width="80">
                  <use :href="`${publicPath}icons.svg#gestion`"/>
                </svg>
                <p class="text-white">{{ $t("transformacion.Gestion-sostenible") }}</p>
              </div>
            </div>
            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
              <div class="boxGris p-4 pb-0">
                <svg viewBox="0 0 70 70" width="80">
                  <use :href="`${publicPath}icons.svg#mantenimiento`"/>
                </svg>
                <p class="text-white">{{ $t("transformacion.Mantenimiento-eficiente") }}</p>
              </div>
            </div>
            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
              <div class="boxGris p-4 pb-0">
                <svg viewBox="-5 0 60 60" width="80">
                  <use :href="`${publicPath}icons.svg#respuesta`"/>
                </svg>
                <p class="text-white">{{ $t("transformacion.Respuesta-rapida") }}</p>
              </div>
            </div>
            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
              <div class="boxGris p-4 pb-0">
                <svg viewBox="0 0 60 60" width="80">
                  <use :href="`${publicPath}icons.svg#estandares`"/>
                </svg>
                <p class="text-white">{{ $t("transformacion.Estandares-seguridad") }}</p>
              </div>
            </div>
            <div class="col-6 col-lg-4 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
              <div class="boxGris p-4 pb-0">
                <svg viewBox="0 0 60 60" width="80">
                  <use :href="`${publicPath}icons.svg#mayor`"/>
                </svg>
                <p class="text-white">{{ $t("transformacion.Mayor-satisfaccion") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-xxl">
    <div class="row justify-content-between g-3 mt-2 py-5">
      <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
        <div class="pt-0 text-start">
          <h4 class="mb-5">{{ $t("transformacion.Nueva-generacion") }}</h4>
          <p class="txtGris" v-html="$t('transformacion.RG-ha-presentado')"></p>
        </div>
      </div>

      <div class="col-12 col-lg-6 position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
        <img :src="`${publicPath}img/01avanzandoTransformacionB.jpg`" class="img-responsive text-end">
      </div>
    </div>
  </div>



  <div class="container-xxl pb-5">
    <div class="row justify-content-end justify-content-lg-center g-0 my-5 bg-dark">
      <div class="col-12 col-lg-9 p-3 py-5 mx-0 pe-2 text-start">
          <h4 class="mb-3">{{ $t("transformacion.Parryware-Bano") }}</h4>
        <p class="txtGris" v-html="$t('transformacion.La-marca-local')"></p>
      </div>
      <div class="col-5 col-lg-2 text-start pt-0 pt-lg-5">
        <img :src="`${publicPath}img/01avanzandoTransformacionB.png`" class="col-10 col-lg-8 mt-0 mt-lg-5 mb-3 mb-lg-0 img-responsive">
      </div>
    </div>
  </div>

  <!-- end Content -->

  <!-- Footer -->
  <footer>
    <div class="row p-0 g-0">
      <div class="col-6 border-top border-dark">
        <localized-link to="/avanzando-hacia-el-futuro/innovacion" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
          <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
            <svg class="hoverEfect svg-icon iconFletxaLeft">
              <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
            </svg>
          </div>
          <div class="col-6 col-lg-auto text-start p-0 mt-5">
            <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
            <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.innovacion") }}</h2>
          </div>
        </localized-link>
      </div>
      <div class="col-6 border-top border-start border-dark">
        <localized-link to="/avanzando-hacia-el-futuro/sostenibilidad" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

          <div class="col-6 col-lg-auto text-end p-0 mt-5">
            <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
            <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.sostenibilidad") }}</h2>
          </div>
          <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
            <svg class="hoverEfect svg-icon iconFletxaRight">
              <use :href="`${publicPath}icons.svg#fletxaRight`"/>
            </svg>
          </div>

        </localized-link>
      </div>
    </div>
  </footer>
  <!-- Footer -->

</template>
<script>
  export default {
    name: "TransformacionDigitalView",
    data() {
      return {
        publicPath: process.env.BASE_URL,
        locale:this.$i18n.locale
      }
    }
  }

</script>